import React from "react";

import { connect } from "react-redux";
import { compose } from "redux";

import { resetUserInfo } from "../../actions/user";
import SuccessPage from "../../components/manage-data/user/new-user-modal/success-page";
import { errorBoundary } from "../../components/general/error-boundary";

const EditApiKeySuccessView = ({ history, match, resetUserInfo }) => (
    <SuccessPage
        editMode={true}
        redirectPath={`/${match.params.item}/registry/apikey`}
        resetUserInfo={resetUserInfo}
        techUser={true}
    />
);

const actions = { resetUserInfo };

const composedHoc = compose(
    errorBoundary,
    connect(() => ({}), actions)
);

export default composedHoc(EditApiKeySuccessView);
